import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Chip,
  Collapse,
  TextField,
  Grid,
  Select,
  MenuItem,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  IconButton,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { useState, useEffect } from "react";
import { get, post } from "../../utils/api";
import SelectField from "../../Components/Masters/SelectField";
import BulkFileUpload from "../Scope1/FugitiveEmmissions/BulkFileUpload";
import { validateNumber } from "../../utils/validateFields";

const BulkUpload = ({
  matchData,
  onClose,
  onConfirm,
  bulkUploadTable,
  bulkuploadInputData,
  url,
  title1,
  title2,
  keyValue1,
  keyValue2,
  options1,
  options2,
  matched1,
  matched2,
  formData,
  setFormData,
  vendorURl,
  setVendorData,
  setEquipmentData,
  EquipmentURl,
  formDatas,
  setFormDatas,
  setMatchData, // Add this prop to update matchData
  jsonBulkUpload = [],
  bulkUploadUrl,
  setsnackOpen,
  fieldName,
}) => {
  const [optionList1, setOptionList1] = useState([]);
  const [optionList2, setOptionList2] = useState([]);
  const [options, setOptions] = useState([]);
  const [EquipmentexpandedRows, setEquipmentExpandedRows] = useState({});
  const [VendorexpandedRows, setVendorExpandedRows] = useState({});
  
  // Form validation state
  const [formErrors, setFormErrors] = useState({});
  const [disabled, setDisabled] = useState(false);
  
  // Document upload state management
  const [finalJson, setFinalJson] = useState(jsonBulkUpload);
  const [uploadValidationErrors, setUploadValidationErrors] = useState([]);
  const [hasValidationBeenAttempted, setHasValidationBeenAttempted] = useState(false);
  
  // Document upload confirmation state
  const [documentUploadConfirmed, setDocumentUploadConfirmed] = useState(false);
  // Document upload type state
  const [documentUploadType, setDocumentUploadType] = useState("none"); // "none", "individual", "same"
  const [commonDocument, setCommonDocument] = useState(null);
  const [individualDocuments, setIndividualDocuments] = useState({});
  // State to show confirmation dialog for proceeding without documents
  const [showNoDocumentDialog, setShowNoDocumentDialog] = useState(false);
  useEffect(() => {
    if (options1) {
      setOptionList1(options1);
    }
    if (options2) {
      setOptionList2(options2);
    }
  }, [options1, options2]);

  // Monitor equipment matching status for button state
  useEffect(() => {
    const allMatched = matchData.every((item, index) => {
      const isMatched = item[matched1] ;
      const isSelected = formData[index]?.equipment && 
        formData[index]?.equipment !== "" && 
        formData[index]?.equipment !== "add_new";
      return isMatched || isSelected;
    });
    const allMatched2 = matchData.every((item, index) => {
      const isMatched = item[matched2] ;
      const isSelected = formData[index]?.vendor && 
        formData[index]?.vendor !== "" && 
        formData[index]?.vendor !== "add_new";
      return isMatched || isSelected;
    });
    setDisabled(!allMatched || !allMatched2);
  }, [formData, matchData, matched1, matched2]);

  useEffect(() => {
    const fetchOptions = async () => {
      const response = await get("/master/getAllIndustrialProcess");
      setOptions(response.data.data);
    };
    fetchOptions();
  }, []);

  // Monitor jsonBulkUpload changes
  useEffect(() => {
    if (jsonBulkUpload && jsonBulkUpload.length > 0) {
      setFinalJson(jsonBulkUpload);
    }
  }, [jsonBulkUpload]);

  // Document upload handler functions
  const handleDocumentUploadConfirmation = (confirmed) => {
    setDocumentUploadConfirmed(confirmed);
    
    if (!confirmed) {
      // Reset document upload type to "none" if user chooses not to upload
      setDocumentUploadType("none");
    }

    // Clear validation errors when document upload confirmation changes
    setUploadValidationErrors([]);
    setHasValidationBeenAttempted(false);
  };

  const handleDocumentUploadTypeChange = (event) => {
    setDocumentUploadType(event.target.value);
    
    setCommonDocument(null);
    setIndividualDocuments({});

    // Clear validation errors when document upload type is selected
    setUploadValidationErrors([]);
    setHasValidationBeenAttempted(false);
  };

  const handleCommonDocumentChange = (files) => {
    setCommonDocument(files);
    
    // Update finalJson with common document for all entries
    if (finalJson && finalJson.length > 0) {
      const updated = finalJson.map((entry) => ({
        ...entry,
        "Document (optional)": files,
      }));
      setFinalJson(updated);
    }

    // Clear validation errors when documents are uploaded
    if (files && files.length > 0) {
      setUploadValidationErrors([]);
      setHasValidationBeenAttempted(false);
    }
  };

  const handleIndividualDocumentChange = (index, files) => {
    setIndividualDocuments((prev) => ({
      ...prev,
      [index]: files,
    }));

    // Update finalJson with individual document for specific entry
    if (finalJson && finalJson.length > 0) {
      const updated = finalJson.map((entry, i) => {
        if (i === index) {
          return {
            ...entry,
            "Document (optional)": files,
          };
        }
        return entry;
      });
      setFinalJson(updated);
    }

    // Clear validation errors when documents are uploaded
    if (files && files.length > 0) {
      setUploadValidationErrors([]);
      setHasValidationBeenAttempted(false);
    }
  };

  const handleClearCommonDocument = () => {
    setCommonDocument(null);
    
    // Update finalJson to clear common document for all entries
    if (finalJson && finalJson.length > 0) {
      const updated = finalJson.map((entry) => ({
        ...entry,
        "Document (optional)": null,
      }));
      setFinalJson(updated);
    }
  };

  const handleClearIndividualDocument = (index) => {
    setIndividualDocuments((prev) => {
      const newDocs = { ...prev };
      delete newDocs[index];
      return newDocs;
    });
    
    // Update finalJson to clear individual document for specific entry
    if (finalJson && finalJson.length > 0) {
      const updated = finalJson.map((entry, i) => {
        if (i === index) {
          return {
            ...entry,
            "Document (optional)": null,
          };
        }
        return entry;
      });
      setFinalJson(updated);
    }
  };

  const handleProceedWithoutDocuments = () => {
    setShowNoDocumentDialog(false);
    performUpload();
  };

  const handleCancelProceedWithoutDocuments = () => {
    setShowNoDocumentDialog(false);
  };

  const validateUploadData = () => {
    const validationErrors = [];

    // Check if user wants to upload documents but hasn't uploaded any
    if (documentUploadConfirmed && documentUploadType === "none") {
      validationErrors.push("Please select a document upload type when document upload is confirmed.");
    }

    // Validate document upload requirements
    if (documentUploadConfirmed && documentUploadType !== "none") {
      const hasCommonDoc = documentUploadType === "same" && commonDocument && commonDocument.length > 0;
      const hasIndividualDocs = documentUploadType === "individual" && 
        Object.keys(individualDocuments).length > 0 &&
        Object.values(individualDocuments).some((docs) => docs && docs.length > 0);
        if (!hasCommonDoc && !hasIndividualDocs) {
      setShowNoDocumentDialog(true);
    }
  }
    return validationErrors;
  };

  const validateEquipmentForm = (index) => {
    const data = formDatas[index] || {};
    const newErrors = {};

    // Validate Industrial Process
    if (!data.industrialProcess || data.industrialProcess === "") {
      newErrors.industrialProcess = "Industrial Process is required";
    }

    // Validate Equipment Name (from the original item)
    if (!matchData[index]?.[keyValue1] || matchData[index][keyValue1] === "") {
      newErrors.equipment = "Equipment Name is required";
    }

    // Validate Brand
    if (!data.brand || data.brand.trim() === "") {
      newErrors.brand = "Brand is required";
    }

    // Validate Model
    if (!data.model || data.model.trim() === "") {
      newErrors.model = "Model is required";
    }

    // Validate Rated Consumption
    if (!data.ratedConsumption || data.ratedConsumption === "") {
      newErrors.ratedConsumption = "Rated Consumption is required";
    } else if (!validateNumber(data.ratedConsumption)) {
      newErrors.ratedConsumption = "Rated Consumption must be a valid positive number";
    }

    // Validate Unit
    if (!data.unit || data.unit === "") {
      newErrors.unit = "Unit is required";
    }

    setFormErrors((prev) => ({
      ...prev,
      [index]: newErrors,
    }));

    return Object.keys(newErrors).length === 0;
  };

  const performUpload = async () => {
    // Use jsonBulkUpload as fallback if finalJson is empty
    const dataToUse = finalJson && finalJson.length > 0 ? finalJson : jsonBulkUpload;

    // Prepare data structure for upload
    const uploadData = {
      excelData: dataToUse,
      documentUploadType: documentUploadType,
      commonDocument: commonDocument,
      individualDocuments: individualDocuments,
    };

    console.log("Final upload data structure:", uploadData);

    if (bulkUploadUrl) {
      await post(bulkUploadUrl, uploadData)
        .then((res) => {
          // Clear validation errors and reset validation attempted flag on successful upload
          setUploadValidationErrors([]);
          setHasValidationBeenAttempted(false);
          setsnackOpen({
            open: true,
            message: res.data.message,
            severity: "success",
          });
          onConfirm();
          onClose();
        })
        .catch((err) => {
          const errMessage = err.response?.data?.details
            ?.map((el) => el?.error)
            ?.join(",");
          if (err?.response?.status === 422) {
          }
          setsnackOpen({
            open: true,
            message: errMessage ?? err.response?.data?.message ?? "Network Error",
            severity: "error",
          });
        });
    } else {
      // Fallback to original onConfirm if no bulkUploadUrl provided
      onConfirm();
    }
  };

  const handleSubmit = async () => {
    // Mark that validation has been attempted
    setHasValidationBeenAttempted(true);

    const validationErrors = validateUploadData();
    console.log(validationErrors, "validationErrors");

    if (validationErrors.length > 0) {
      setUploadValidationErrors(validationErrors);
      return;
    }

    // Check if user wants to upload documents but hasn't uploaded any
    const needsDocs = documentUploadConfirmed && documentUploadType !== "none";

    if (needsDocs) {
      const hasCommonDoc = documentUploadType === "same" && commonDocument && commonDocument.length > 0;
      const hasIndividualDocs = documentUploadType === "individual" && 
        Object.keys(individualDocuments).length > 0 &&
        Object.values(individualDocuments).some((docs) => docs && docs.length > 0);

      if (!hasCommonDoc && !hasIndividualDocs) {
        setShowNoDocumentDialog(true);
        return;
      }
    }

    // If no dialog is needed, proceed with upload
    await performUpload();
  };

  if (!matchData || matchData.length === 0) {
    return null;
  }
  const handleChange = (index, e, equipmentValue) => {
    const { name, value } = e.target;
    
    // Restrict ratedConsumption to numbers only
    if (name === "ratedConsumption" && !/^\d*$/.test(value)) return;
    
    setFormDatas((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        [name]: value,
        equipment: equipmentValue,
      },
    }));

    // Clear validation errors for this field when user starts typing
    if (formErrors[index]?.[name]) {
      setFormErrors((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          [name]: "",
        },
      }));
    }
  };

  // console.log(matchData, "matchData");

  const handleFormChange = (index, field, value) => {
    const fieldName = field === "equipment" ? "Equipment" : field === "vendor" ? "Vendor Name" : field;
    // Update formData
    setFormData((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        [field]: value,
      },
    }));

    // Handle Equipment Expand/Collapse
    if (field === "equipment") {
      if (value === "add_new") {
        setEquipmentExpandedRows((prev) => ({
          ...prev,
          [index]: true,
        }));
      } else {
        setEquipmentExpandedRows((prev) => ({
          ...prev,
          [index]: false,
        }));
      }
    }

    // Handle Vendor Expand/Collapse
    if (field === "vendor") {
      if (value === "add_new") {
        setVendorExpandedRows((prev) => ({
          ...prev,
          [index]: true,
        }));
      } else {
        setVendorExpandedRows((prev) => ({
          ...prev,
          [index]: false,
        }));
      }
    }

    // Optional: Reset fields except selected field
    if (
      (field === "equipment" || field === "vendor") &&
      value !== "add_new" &&
      value !== ""
    ) {
      setFormData((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          [field]: value,
        }
      }));
      setFinalJson((prev) => {
        const newArray = [...prev];
        newArray[index] = {
          ...newArray[index],
          [fieldName]: value,
        };
        return newArray;
      });
    }
  };
  const handleAddItem = async (index, value, key) => {
    // if (validateForm(index)) {
    //   return;
    // }

    try {
      // Make API call here
      const response = await post(vendorURl, { VendorLegalFullName: value });
      setsnackOpen({
        open: true,
        message: response.data.message,
        severity: "success",
      });
      // For now, simulate API call success
      await new Promise((resolve) => setTimeout(resolve, 1000));

      // Update the status to matched on success
      if (setVendorData) {
        setFormData((prev) => ({
          ...prev,
          [index]: {
            ...prev[index],
            [key]: true,
          },
        }));
        if (setMatchData) {
          // Update the matchData to reflect the matched status
          const updatedMatchData = matchData.map((item, i) =>
            i === index ? { ...item, [key]: true } : item
          );
          setMatchData(updatedMatchData);
        }
      }

      // Call the parent handler if provided

      // Close the expanded row
      setVendorExpandedRows((prev) => ({
        ...prev,
        [index]: false,
      }));

      // Clear form data and errors for this index
      setFormData((prev) => {
        const newData = { ...prev };
        delete newData[index];
        return newData;
      });

      setFormDatas((prev) => {
        const newData = { ...prev };
        delete newData[index];
        return newData;
      });

      // Clear form errors for this index
      setFormErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[index];
        return newErrors;
      });
    } catch (error) {
      console.error("Error adding equipment:", error);
      // Handle error - you can show an error message here
    }
  };
  const handleEquipemntAddItem = async (index, value, key) => {
    // Validate the form before proceeding
    if (!validateEquipmentForm(index)) {
      return;
    }

    const itemData = {
      //   equipment: matchData[index].equipment,
      ...formDatas[index],
    };

    try {
      // Make API call here
      // Example: const response = await addEquipmentAPI(itemData);
      const response =  await post(EquipmentURl, { ...itemData });
      setsnackOpen({
        open: true,
        message: response.data.message,
        severity: "success",
      });
      // For now, simulate API call success
      await new Promise((resolve) => setTimeout(resolve, 1000));

      // Update the status to matched on success
      if (setEquipmentData) {
        setFormData((prev) => ({
          ...prev,
          [index]: {
            ...prev[index],
            [key]: true,
          },
        }));
       
      }
      if (setMatchData) {
        // Update all rows with the same equipment value to matched
        const equipmentValue = formDatas[index]?.equipment;
        const updatedMatchData = matchData.map((item) =>
          item[keyValue1] === equipmentValue ? { ...item, [key]: true } : item
        );
        setMatchData(updatedMatchData);
      }

      // Call the parent handler if provided

      // Close the expanded row
      setEquipmentExpandedRows((prev) => ({
        ...prev,
        [index]: false,
      }));

      // Clear form data and errors for this index
      setFormData((prev) => {
        const newData = { ...prev };
        delete newData[index];
        return newData;
      });

      
    } catch (error) {
      console.error("Error adding equipment:", error);
      // Handle error - you can show an error message here
    }
  };
  return (
    <>
    <Dialog
      open={bulkUploadTable}
      onClose={onClose}
      maxWidth="lg"
      sx={{
        "& .MuiDialog-paper": {
          width: "70%",
          margin: "16px",
          maxHeight: "calc(100% - 32px)",
          zIndex: 1000,
        },
      }}
    >
      <DialogTitle>Review Bulk Upload Data</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Review the matched and unmatched equipment data. Add unmatched items
          individually.
        </Typography>

        <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
          <Table stickyHeader>
            <TableHead sx={{ overflowX: "hidden" }}>
              <TableRow>
                <TableCell
                  sx={{ fontWeight: "bold", width: title2 ? "15%" : "50%" }}
                >
                  Data Entered
                </TableCell>
                {title2 && (
                  <TableCell
                    sx={{ fontWeight: "bold", width: "8%" }}
                  ></TableCell>
                )}
                
                <TableCell
                  sx={{ fontWeight: "bold", width: title2 ? "15%" : "50%" }}
                >
                  Master Data
                </TableCell>
                {title2 && (
                  <TableCell
                    sx={{ fontWeight: "bold", width: "10%" }}
                  ></TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{ fontWeight: "bold", width: title2 ? "18%" : "50%" }}
                >
                  {title1 ? title1 : "Equipment Name"}
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", width: title2 ? "15%" : "50%" }}
                >
                  {title2 ? title2 : "Equipment Name"}
                </TableCell>
                
                <TableCell sx={{ fontWeight: "bold", width: "20%" }}>
                  {title1 ? title1 : "Equipment Name"}
                </TableCell>
                <TableCell
                  sx={{ fontWeight: "bold", width: title2 ? "10%" : "50%" }}
                >
                  Action
                </TableCell>
                {title2 && (
                  <TableCell sx={{ fontWeight: "bold", width: "20%" }}>
                    {title2 ? title2 : "Equipment Name"}
                  </TableCell>
                )}

                <TableCell
                  sx={{ fontWeight: "bold", width: title2 ? "10%" : "50%" }}
                >
                  Action
                </TableCell>
                {documentUploadConfirmed && documentUploadType === "individual" && (
                  <TableCell sx={{ fontWeight: "bold", width: "15%" }}>
                    Document
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {matchData?.map((item, index) => (
                <>
                  <TableRow key={index}>
                    <TableCell>
                      {keyValue1 ? item?.[keyValue1] : item.equipment}
                    </TableCell>
                    {title2 && (
                      <TableCell>
                        {keyValue2 ? item?.[keyValue2] : item.equipment}
                      </TableCell>
                    )}
                    <TableCell>
                      {item[matched1] ? (
                        <Chip label="Matched" color="success" size="small" />
                      ) : (
                        <FormControl
                          size="small"
                          sx={{
                            minWidth: title2 ? "8rem" : "10rem",
                            maxWidth: title2 ? "8rem" : "10rem",
                          }}
                        >
                          <Select
                            value={formData?.[index]?.[keyValue1] || ""}
                            onChange={(e) =>
                              handleFormChange(index, keyValue1, e.target.value)
                            }
                            fullWidth
                            displayEmpty
                            disabled={item[matched1]}
                          >
                            <MenuItem value="">Tap to Select</MenuItem>

                            <MenuItem value="add_new">
                              Add New Equipment +
                            </MenuItem>

                            {optionList1 &&
                              optionList1.map((item, index) => {
                                return <MenuItem value={item}>{item}</MenuItem>;
                              })}
                          </Select>
                        </FormControl>
                      )}
                    </TableCell>
                    <TableCell>
                      {!item.matched &&
                        (formDatas[index]?.equipment === "add_new" ||
                        EquipmentexpandedRows[index] ? (
                          <Button
                            variant="contained"
                            size="small"
                            onClick={() => {
                              setEquipmentExpandedRows((prev) => ({
                                ...prev,
                                [index]: !prev[index],
                              }));
                            }}
                            sx={{ minWidth: "80px" }}
                          >
                            {EquipmentexpandedRows[index] ? "Close" : "Open"}
                          </Button>
                        ) : null)}
                    </TableCell>

                    
                    {title2 && (
                      <TableCell>
                        {item[matched2] ? (
                          <Chip label="Matched" color="success" size="small" />
                        ) : (
                          <FormControl
                            size="small"
                            sx={{ minWidth: "7rem", maxWidth: "7rem" }}
                          >
                            <Select
                              value={formData?.[index]?.[keyValue2] || ""}
                              onChange={(e) =>
                                handleFormChange(
                                  index,
                                  keyValue2,
                                  e.target.value
                                )
                              }
                              fullWidth
                              displayEmpty
                              disabled={item[matched2]}
                            >
                              <MenuItem value="">Tap to Select</MenuItem>
                              {/* {addNew !== false && ( */}
                              <MenuItem value="add_new">
                                Add New Vendor +
                              </MenuItem>
                              {/* )} */}
                              {optionList2 &&
                                optionList2.map((item, index) => {
                                  return (
                                    <MenuItem value={item}>{item}</MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                        )}
                      </TableCell>
                    )}
                    <TableCell>
                      {!item.matched &&
                        (formData[index]?.vendor === "add_new" ||
                        VendorexpandedRows[index] ? (
                          <Button
                            variant="contained"
                            size="small"
                            onClick={() => {
                              setVendorExpandedRows((prev) => ({
                                ...prev,
                                [index]: !prev[index],
                              }));
                            }}
                            sx={{ minWidth: "80px" }}
                          >
                            {VendorexpandedRows[index] ? "Close" : "Open"}
                          </Button>
                        ) : null)}
                    </TableCell>
                    {documentUploadConfirmed && documentUploadType === "individual" && (
                      <TableCell>
                        <BulkFileUpload
                          filesList={individualDocuments[index] || []}
                          handleChange={handleIndividualDocumentChange}
                          handleClear={handleClearIndividualDocument}
                          index={index}
                        />
                      </TableCell>
                    )}
                  </TableRow>
                  {/* Expandable form row */}
                  {/* Expandable form row */}
                  <TableRow>
                    <TableCell
                      style={{ paddingBottom: 0, paddingTop: 0 }}
                      colSpan={documentUploadConfirmed && documentUploadType === "individual" ? 4 : 4}
                    >
                      <Collapse
                        in={EquipmentexpandedRows[index]}
                        timeout="auto"
                        unmountOnExit
                      >
                        <Typography
                          variant="subtitle1"
                          sx={{ fontWeight: "bold", mt: 1, mb: 2 }}
                        >
                          Add Electricity Equipment
                        </Typography>

                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                           
                            <SelectField
                              title="Industrial Process"
                              field="industryProcess"
                              variant="outlined"
                              options={options}
                              value={formDatas?.[index]?.industrialProcess}
                              handleChange={(e) =>
                                handleChange(index, e, item[keyValue1])
                              }
                              fullWidth
                              name="industrialProcess"
                              placeholder="Name"
                              error={!!formErrors[index]?.industrialProcess}
                              InputLabelProps={{
                                style: { color: formErrors[index]?.industrialProcess ? "#D34040" : undefined },
                              }}
                              errors={formErrors[index]?.industrialProcess}
                              mt="0.7rem"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} sx={{ mt: 0.4 }}>
                            <Typography
                              variant="subtitle1"
                              sx={{ fontWeight: "bold", mt: 1 }}
                            >
                              Equipment Name
                            </Typography>
                            <TextField
                              // select
                              variant="outlined"
                              size="small"
                              // value={formData?.[index]?.equipment}
                              // onChange={handleChange}
                              fullWidth
                              name="equipment"
                              placeholder="Name"
                              value={item?.[keyValue1]}
                              disabled={item[matched1] ? true : false}
                              error={!!formErrors[index]?.equipment}
                              InputLabelProps={{
                                style: { color: formErrors[index]?.equipment ? "#D34040" : undefined },
                              }}
                            />
                            {formErrors[index]?.equipment && (
                              <Typography variant="body2" color="#D34040" sx={{ mt: 0.5 }}>
                                {formErrors[index].equipment}
                              </Typography>
                            )}
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <Typography
                              variant="subtitle1"
                              sx={{ fontWeight: "bold", mt: 1 }}
                            >
                              Brand
                            </Typography>
                            <TextField
                              //  select
                              variant="outlined"
                              size="small"
                              value={formDatas?.[index]?.brand}
                              onChange={(e) =>
                                handleChange(index, e, item[keyValue1])
                              }
                              fullWidth
                              name="brand"
                              placeholder="Name"
                              error={!!formErrors[index]?.brand}
                              InputLabelProps={{
                                style: { color: formErrors[index]?.brand ? "#D34040" : undefined },
                              }}
                            />
                            {formErrors[index]?.brand && (
                              <Typography variant="body2" color="#D34040" sx={{ mt: 0.5 }}>
                                {formErrors[index].brand}
                              </Typography>
                            )}
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <Typography
                              variant="subtitle1"
                              sx={{ fontWeight: "bold", mt: 1 }}
                            >
                              Model
                            </Typography>
                            <TextField
                              //  select
                              variant="outlined"
                              size="small"
                              value={formDatas?.[index]?.model}
                              onChange={(e) =>
                                handleChange(index, e, item[keyValue1])
                              }
                              fullWidth
                              name="model"
                              placeholder="Name"
                              error={!!formErrors[index]?.model}
                              InputLabelProps={{
                                style: { color: formErrors[index]?.model ? "#D34040" : undefined },
                              }}
                            />
                            {formErrors[index]?.model && (
                              <Typography variant="body2" color="#D34040" sx={{ mt: 0.5 }}>
                                {formErrors[index].model}
                              </Typography>
                            )}
                           
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <Typography
                              variant="subtitle1"
                              sx={{ fontWeight: "bold", mt: 1 }}
                            >
                              Rated Consumption / Hour{" "}
                            </Typography>
                            <TextField
                              //  select
                              variant="outlined"
                              size="small"
                              value={formDatas?.[index]?.ratedConsumption}
                              onChange={(e) =>
                                handleChange(index, e, item[keyValue1])
                              }
                              fullWidth
                              name="ratedConsumption"
                              placeholder="1200"
                              error={!!formErrors[index]?.ratedConsumption}
                              InputLabelProps={{
                                style: { color: formErrors[index]?.ratedConsumption ? "#D34040" : undefined },
                              }}
                            />
                            {formErrors[index]?.ratedConsumption && (
                              <Typography variant="body2" color="#D34040" sx={{ mt: 0.5 }}>
                                {formErrors[index].ratedConsumption}
                              </Typography>
                            )}
                            
                          </Grid>
                          <Grid item xs={12} sm={6} sx={{ mt: "0.5rem" }}>
                          

                            <SelectField
                            title="Unit"
                              value={formDatas?.[index]?.unit || ""}
                              handleChange={(e) =>
                                handleChange(index, e, item[keyValue1])
                              }
                              fullWidth
                              size="small"
                              name="unit"
                              options={[
                                "Ampere",
                                "Watt",
                                "KWH",
                                "Volts",
                                "Resistance",
                                "Ohm",
                              ]}
                              placeholder="Unit"
                              error={!!formErrors[index]?.unit}
                              InputLabelProps={{
                                style: { color: formErrors[index]?.unit ? "#D34040" : undefined },
                              }}
                              errors={formErrors[index]?.unit}
                              mt="0px"
                            />
                             
                          
                          </Grid>
                        </Grid>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            mb: 2,
                          }}
                        >
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() =>
                              handleEquipemntAddItem(
                                index,
                                item[keyValue1],
                                matched1
                              )
                            }
                            sx={{ mt: 1 }}
                          >
                            Add Equipment
                          </Button>
                        </Box>
                      </Collapse>
                    </TableCell>
                    <TableCell
                      style={{ paddingBottom: 0, paddingTop: 0 }}
                      colSpan={3}
                    >
                      <Collapse
                        in={VendorexpandedRows[index]}
                        timeout="auto"
                        unmountOnExit
                      >
                        <Typography
                          variant="subtitle1"
                          sx={{ fontWeight: "bold", mt: 1 }}
                        >
                          Vendor Legal Full Name
                        </Typography>

                        <TextField
                          //   select
                          variant="outlined"
                          value={item?.[keyValue2]}
                          disabled={item[matched2] ? true : false}
                          size="small"
                          fullWidth
                          name="VendorLegalFullName"
                          placeholder="Vendor Legal Full Name"
                         
                        />
                       

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            mb: 2,
                          }}
                        >
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() =>
                              handleAddItem(index, item[keyValue2], matched2)
                            }
                            sx={{ mt: 1 }}
                          >
                            Add Vendor
                          </Button>
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Document Upload Section */}
        <Box
          sx={{ mt: 3, p: 2, border: "1px solid #e0e0e0", borderRadius: 1 }}
        >
          <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
            Document Upload
          </Typography>
          <Box>
            <FormControl component="fieldset">
              <FormLabel component="legend">
                Do you want to upload document?
              </FormLabel>
              <RadioGroup
                value={documentUploadConfirmed ? "yes" : "no"}
                onChange={(e) =>
                  handleDocumentUploadConfirmation(e.target.value === "yes")
                }
                row
              >
                <FormControlLabel
                  value="yes"
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Box>
          {documentUploadConfirmed && (
            <FormControl component="fieldset" sx={{ mb: 2, mt: 2 }}>
              <FormLabel component="legend">Document Upload Type</FormLabel>
              <RadioGroup
                value={documentUploadType}
                onChange={handleDocumentUploadTypeChange}
                row
              >
                <FormControlLabel
                  value="same"
                  control={<Radio />}
                  label="Same File for All Records"
                />
                <FormControlLabel
                  value="individual"
                  control={<Radio />}
                  label="Individual File for Each Record"
                />
              </RadioGroup>
            </FormControl>
          )}

          {documentUploadConfirmed && documentUploadType === "same" && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Upload a single document that will be associated with all
                records:
              </Typography>
              <BulkFileUpload
                filesList={commonDocument}
                handleChange={handleCommonDocumentChange}
                handleClear={handleClearCommonDocument}
              />
            </Box>
          )}

          {documentUploadConfirmed && documentUploadType === "individual" && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Upload individual documents for each record. Documents will
                be added as a new column in the table above.
              </Typography>
            </Box>
          )}
        </Box>

        {/* Validation Error Display - Only show after validation has been attempted */}
        {hasValidationBeenAttempted && uploadValidationErrors.length > 0 && (
          <Box
            sx={{
              mt: 2,
              p: 2,
              backgroundColor: "#ffebee",
              borderRadius: 1,
              border: "1px solid #f44336",
            }}
          >
            <Typography
              variant="h6"
              color="error"
              sx={{ mb: 1, fontWeight: "bold" }}
            >
              Error:
            </Typography>
            {uploadValidationErrors.map((error, index) => (
              <Typography
                key={index}
                variant="body2"
                color="error"
                sx={{ mb: 0.5 }}
              >
                • {error}
              </Typography>
            ))}
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ padding: "1rem" }}>
        <Button
          onClick={()=>{setFormDatas({});onClose()}}
          variant="outlined"
          color="primary"
          sx={{ marginRight: "1rem" }}
        >
          Cancel
        </Button>
        <Button 
          onClick={handleSubmit} 
          variant="contained" 
          color="primary"
          disabled={disabled}
        >
          Confirm Upload
        </Button>
      </DialogActions>
    </Dialog>

    {/* Confirmation Dialog for Proceeding Without Documents */}
    <Dialog
      open={showNoDocumentDialog}
      onClose={handleCancelProceedWithoutDocuments}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="h6">No Documents Uploaded</Typography>
          <IconButton
            onClick={handleCancelProceedWithoutDocuments}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          You have selected to upload documents but haven't uploaded any files.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Do you want to proceed without uploading documents?
        </Typography>
        <Typography variant="body2" color="text.secondary">
          You can still upload documents later if needed.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ padding: "1rem" }}>
        <Button
          onClick={handleCancelProceedWithoutDocuments}
          variant="outlined"
          color="primary"
          sx={{ marginRight: "1rem" }}
        >
          Upload Documents
        </Button>
        <Button
          onClick={handleProceedWithoutDocuments}
          variant="contained"
          color="primary"
        >
          Proceed Without Documents
        </Button>
      </DialogActions>
    </Dialog>
  </>
  );
};

export default BulkUpload;
